import { render, staticRenderFns } from "./Reglementaire.vue?vue&type=template&id=320bdccf&scoped=true&"
import script from "./Reglementaire.vue?vue&type=script&lang=js&"
export * from "./Reglementaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320bdccf",
  null
  
)

export default component.exports